import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrlApi } from "../../proxy";

interface KorbaDetails {
  access_token: string | undefined;
  model: string | undefined;
}

/*--------------------------GET ALL KORBAS-----------------------------*/
export const getAllKorba = createAsyncThunk("korba/get-korba", async () => {
  try {
    const response = await axios.get(`${baseUrlApi}korba`);
    return response?.data;
  } catch (error) {
    throw error;
  }
});

export const getAllKorbaTypes = createAsyncThunk(
  "korba/get-korba-types",
  async () => {
    try {
      const response = await axios.get(`${baseUrlApi}donation/korba/types `);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const getAllCompletedKorba = createAsyncThunk(
  "korba/get-completed-korba",
  async () => {
    try {
      const response = await axios.get(`${baseUrlApi}completed/korba`);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const getAllKorbaAssistance = createAsyncThunk(
  "korba/get-korba-assistance",
  async () => {
    try {
      const response = await axios.get(
        `${baseUrlApi}beneficiary/assistances/types`
      );
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);
export const getKorbaHomePage = createAsyncThunk(
  "homeKorba/get-homeKorba",
  async () => {
    try {
      const response = await axios.get(`${baseUrlApi}homepage/korba`);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const getDetailsKorba = createAsyncThunk(
  "korbas/getDetais",
  async ({ access_token, model }: KorbaDetails) => {
    try {
      const response = await axios.post(
        `${baseUrlApi}korba`,
        {
          access_token,
          model,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);
